import React, { useState, useEffect } from 'react';
import {
  OutageDetailsByCounty,
  ZipCodeInfo,
} from '../../../../__generated__/pge-types';
import OutageCountyListPanel from '../outages-and-accounts-panel/OutageCountyListPanel';
import OutageByZipCodePopup from '../outage-by-zip-code/OutageByZipCodePopup';
import { useReportOutageApi } from '../outage-map-panel/useOutageReportApi';
import { useIsMobile } from '../../../../util/style-utils';

interface Props {
  handleOutageByZipClick: (show: boolean) => void;
  totalOutages: number;
  showOutageByZipPopup: boolean;
  handleZipcodeClick: (
    countyName: string | null | undefined,
    zipCode?: string | null | undefined,
    zipIndex?: number | null | undefined,
    zipCodes?: Array<ZipCodeInfo> | undefined | null,
  ) => void;
  handleMobileOutageListPanel?: () => void;
}
export const OutageListAndZipPanel = (props: Props) => {
  const {
    handleOutageByZipClick,
    totalOutages,
    showOutageByZipPopup,
    handleZipcodeClick,
    handleMobileOutageListPanel,
  } = props;
  const isMobile = useIsMobile();

  const { getOutagesByCounty } = useReportOutageApi();
  const [outageByCounty, setOutageByCounty] = useState<
    OutageDetailsByCounty[] | undefined
  >();
  const [isOutageByCountyLoading, setIsOutageByCountyLoading] = useState<
    boolean
  >(true);
  const [isOutageByCountyError, setIsOutageByCountyError] = useState<boolean>(
    false,
  );

  useEffect(() => {
    void fetchOutagesByCounty();
  }, []);

  useEffect(() => {
    if ((outageByCounty && outageByCounty.length) || isOutageByCountyError) {
      setIsOutageByCountyLoading(false);
    }
  }, [outageByCounty, isOutageByCountyError]);

  const fetchOutagesByCounty = async () => {
    try {
      const result = await getOutagesByCounty({ county: '' });
      if (result && result?.data) {
        setOutageByCounty(result.data);
        setIsOutageByCountyLoading(false);
      } else if (Boolean(result.errors)) {
        setIsOutageByCountyError(true);
        setIsOutageByCountyLoading(false);
      } else {
        setIsOutageByCountyError(true);
        setIsOutageByCountyLoading(false);
      }
    } catch {
      setIsOutageByCountyError(true);
      setIsOutageByCountyLoading(false);
    }
  };

  return (
    <>
      {isMobile && (
        <OutageCountyListPanel
          totalOutages={totalOutages}
          outageByCounty={outageByCounty}
          handleZipcodeClick={handleZipcodeClick}
          isOutageByCountyLoading={isOutageByCountyLoading}
          isOutageByCountyError={isOutageByCountyError}
          handleMobileOutageListPanel={handleMobileOutageListPanel}
        />
      )}
      {!isMobile && (
        <OutageByZipCodePopup
          showOutageByZipPopup={showOutageByZipPopup}
          handleOutageByZipClick={handleOutageByZipClick}
          handleZipcodeClick={handleZipcodeClick}
          outageByCounty={outageByCounty}
          isOutageByCountyLoading={isOutageByCountyLoading}
          isOutageByCountyError={isOutageByCountyError}
        />
      )}
    </>
  );
};

export default OutageListAndZipPanel;
